import React from 'react';
import { MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-900 text-white pt-16 pb-8 border-t border-navy-800" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12" data-id="element-65">
          <div className="mb-8 md:mb-0 text-center md:text-left" data-id="element-66">
            <h2 className="text-3xl font-bold mb-2" data-id="element-67">Tech Vero Solutions</h2>
            <p className="text-navy-200 max-w-md" data-id="element-68">
              Empowering businesses with innovative digital solutions. Your
              partner in growth and technological excellence.
            </p>
          </div>

          <div data-id="element-69">
            <a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-whatsapp hover:bg-[#1da851] text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-green-900/20 transform hover:-translate-y-1" data-id="element-70">
              <MessageCircle className="mr-2 h-6 w-6" data-id="element-71" />
              Contact Us on WhatsApp
            </a>
          </div>
        </div>

        <div className="border-t border-navy-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-navy-300" data-id="element-72">
          <p data-id="element-73">
            &copy; {new Date().getFullYear()} Tech Vero Solutions. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-74">
            <a href="#" className="hover:text-white transition-colors" data-id="element-75">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-76">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}